<template>
  <div class="page">
    <!-- 头部 -->
    <Header title="礼品详情" :righyIcon="getImageUri('/img/sort/good-cart@2x.png')" :rightHandler="shoppingCar"  :leftHandler="onClickLeft" />
    <!-- 轮播图 -->
    <van-swipe class="home-swipe" :autoplay="3000" indicator-color="#117281" height="250">
      <template v-if="imageList.length">
        <van-swipe-item v-for="(item, index) in imageList" :key="index">
          <van-image :src="(filePrefix +item.fileUri)" class="van-img" fit="contain"></van-image>
        </van-swipe-item>
      </template>
      <van-swipe-item v-else>
        <van-image class="van-img"></van-image>
      </van-swipe-item>
    </van-swipe>
    <!-- 内容 -->
    <div class="goods-detail-nav">
      <div class=" container">
        <div class="good-name">礼品名称：{{ itemInfo.itemName }}</div>
        <div v-if='!isCourseItem && !viewStock'>库存：已售完</div>
        <div class="color999" v-if='!isCourseItem && viewStock'>
          库存：{{ itemInfo.usableStock }}件
          <span v-if="itemInfo.isPreOrder == 1">(可预定)</span>
        </div>
        <div class="col-25 text-right color999" v-if='isOfflineCourse'>
          <span v-if="isCourseCutoff" class="theme-red-color">已截止</span>
          <span v-if="!isCourseCutoff">可参加</span>
        </div>
        <div class="col-25 text-right color999" v-if='isOnlineCourse'>
          <span>评分：{{ itemInfo.courseScore }}</span>
        </div>
      </div>
      <div class=" container subItemLink">礼品编号：{{itemInfo.itemCode}}</div>

      <div class="container subItemLink" v-if='itemInfo.subItemLinkList && itemInfo.subItemLinkList.length > 0'>
        <div class="color333">礼品套包：</div>
        <div>
          <div class="color333 subItemLink-item" v-for="(subItemLink,index) in itemInfo.subItemLinkList" :key="index">
            <div class="col-33">{{subItemLink.subItem.itemName}}</div>
            <div class="col-33">{{subItemLink.subItem.itemCode}}</div>
            <div class="col-25">&times;{{subItemLink.subItemQuantity}}</div>
          </div>
        </div>
      </div>
      <div class=" container">
        <div class="col-75 theme-red-color" style="font-size:18px;">{{ itemInfo.firstPointTypeName }}
          <span v-if='itemInfo.isSpecial'>(特殊)</span>：
          <span v-if='itemInfo.isPromotion == 0'>{{ itemInfo.exchangePoint }}积分</span>
          <span v-if='itemInfo.isPromotion == 1'>{{ itemInfo.promotionPoint }}
            积分<span class="search-result-oldintegration">{{ itemInfo.exchangePoint }}积分</span></span>
        </div>
        <div class="col-25 text-right">
          <span
            :class="{'goods-collection-icon': itemInfo.isFavorite == 0, 'goods-collectioned-icon': itemInfo.isFavorite == 1}"
            @click="collection"></span>
          <span class="goods-share-icon"></span>
          <a v-if="itemInfo.buyLink" :href="itemInfo.buyLink">
            <van-icon name="weapp-nav" size="20" color="#117281"></van-icon>
          </a>
        </div>
      </div>

      <div class="container color333">
        <div v-if='itemInfo.mOQMultiple == undefined && itemInfo.mOQ != undefined'>最小起订量：{{ itemInfo.mOQ }}</div>
        <div v-if="itemInfo.mOQMultiple != undefined && itemInfo.mOQ == undefined">最小起订倍数：{{ itemInfo.mOQMultiple }}
        </div>
        <div v-if="itemInfo.mOQMultiple != undefined && itemInfo.mOQ != undefined">最小起订倍数：{{ itemInfo.mOQMultiple }}
        </div>
      </div>

      <div class="lesson" v-if="isOfflineCourse">
        <div class="col-75 color333">时间：{{ itemInfo.startTime | parseTime('{y}-{m}-{d}') }} - {{ itemInfo.endTime |
        parseTime('{y}-{m}-{d}') }}</div>
        <div class="col-25 color333">地点：{{ itemInfo.courseLocation }}</div>
      </div>
      <div class="lesson" v-if="isOfflineCourse">
        <div class="color333">报名截止：{{ itemInfo.cutoffTime | parseTime('{y}-{m}-{d}') }}</div>
      </div>
      <div class="lesson color333" v-if="isOnlineCourse">
        课时：{{ itemInfo.lessonPeriod }}
      </div>
      <div v-if="isCourseItem && orderCount > 0" class="order-count">
        您已经兑换过该课程{{ orderCount }}次
      </div>
    </div>
    <!-- 礼品种类 -->
    <div v-if="hasSubItems" class="goods-option">
      <div v-if="!itemInfo.tagReveal" class="goods-type">
        <div class="subItem-name">礼品种类</div>
        <div class="subItem-list">
          <van-button plain hairline type="primary" v-for="(subItem,index) in itemInfo.subItemVOs" :key="index"
            @click="toggltSubitem(subItem,index)" :class="{'active':index == subItemIndex}">
            {{subItem.itemInfo.showLabel || subItem.itemInfo.itemName}}
          </van-button>
        </div>
      </div>
      <div v-if="itemInfo.tagReveal==1">
        <div v-if="itemInfo.itemTagVO.itemTagType ==='01'" class="goods-type">
          <div class="pull-left subItem-name">款式</div>
          <div class="subItem-list">
            <van-button plain hairline type="primary" round size="small"
              v-for="(subItem,index) in itemInfo.itemTagVO.itemTagNameList" :key="index"
              @click="updateSelected(index,'01',subItem)" :class="{'active':index == shapeItemIndex}">
              {{subItem}}
            </van-button>
          </div>
        </div>
        <div v-if="itemInfo.itemTagVO.itemTagType==='02'|| (itemColorTagList && itemColorTagList.length)"
          class="goods-type">
          <div class="subItem-name">颜色</div>
          <div class="subItem-list">
            <van-button plain hairline type="primary" round size="small" v-for="(subItem,index) in itemColorTagList"
              :key="index" @click="updateSelected(index,'02',subItem)" :class="{'active':index == colorItemIndex}">
              {{subItem}}
            </van-button>
          </div>
        </div>
        <div v-if="itemInfo.itemTagVO.itemTagType==='03'||(itemSizeTagList&&itemSizeTagList.length)" class="goods-type">
          <div class="subItem-name">大小</div>
          <div class="subItem-list">
            <van-button plain hairline type="primary" round size="small" v-for="(subItem,index) in itemSizeTagList"
              :key="index" @click="updateSelected(index,'03',subItem)" :class="{'active':index == sizeItemIndex}">
              {{subItem}}
            </van-button>
          </div>
        </div>
      </div>
    </div>
    <!-- tabs -->
    <van-tabs swipeable class="tabs">
      <van-tab title="礼品详情">
        <div v-html="itemInfo.itemDesc" class="goods-html goods-html-specInfo"></div>
      </van-tab>
      <van-tab title="规格参数">
        <div v-html="itemInfo.specInfo" class="goods-html goods-html-specInfo"></div>
      </van-tab>
    </van-tabs>
    <div style="height: 40px;"></div>
    <!-- 底部按钮 -->
    <div class="fixed">
      <template v-if="!isCourseItem">
        <van-button color="#87c0ca" class="flex-1" @click="addToCart">加入购物车</van-button>
        <van-button type="primary" class="flex-1" @click="directBuy" v-if="userRole !== '03'">立即兑换</van-button>
      </template>
      <van-button type="primary" color="#87c0ca" class="flex-1" v-if="isOfflineCourse && userRole !== '03'"
        @click="offlineCourseBuy">立即兑换</van-button>
      <template v-if="isOnlineCourse">
        <van-button type="primary" class="flex-1" v-if="orderCount == 0  && userRole !== '03'" @click="onlineCourseBuy">
          立即兑换</van-button>
        <van-button type="primary" class="flex-1" v-if="orderCount > 0" @click="viewOnlineCourse">打开课程</van-button>
      </template>
    </div>
    <van-dialog v-model="dialogCiamOption.dialogCiamShow" :title="dialogCiamOption.title"
      :message="dialogCiamOption.message" show-cancel-button :confirmButtonColor="dialogCiamOption.confirmButtonColor"
      :confirmButtonText="dialogCiamOption.confirmButtonText" :cancelButtonText="dialogCiamOption.cancelButtonText"
      @confirm="dialogCiam">
    </van-dialog>
  </div>

</template>
<script>
import Header from '@/components/header'
import sortApi from '@/api/sort'
import cartApi from '@/api/cart'
import { userUtils } from '@/utils/auth'
import { commonUtils } from '@/utils/common'
import { mapState } from 'vuex'
export default {
  name: 'HomeMain',
  components: {
    Header
  },
  data () {
    return {
      itemId: '',
      imageList: [],
      itemInfo: {},
      orderCount: 0,
      subItemId: -999, // 礼品组选择的礼品id
      userStatus: 1,
      dialogCiamOption: {
        dialogCiamShow: false,
        title: '温馨提示',
        message: '该课程需要CIAM登录才能购买，是否前往CIAM登录?',
        confirmButtonColor: '#117281',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      },
      subItemIndex: -1,
      shapeItemIndex: -1,
      colorItemIndex: -1,
      sizeItemIndex: -1,
      viewStock: true,
      hasSubItems: false,
      itemColorTagList: [],
      itemSizeTagList: [],
      couponId: ''
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      filePrefix: state => state.base.ApiEndpoint.fileUrl,
      userRole: state => state.user.userRole, // 01老板，02采购，03小工
      clientInfo: state => state.user.clientInfo
    }),
    // 判断是否线下课程
    isOfflineCourse () {
      return this.itemInfo && this.itemInfo.itemCategory && this.itemInfo.itemCategory.categoryCode === '1031'
    },
    // 判断是否线上课程
    isOnlineCourse () {
      return (this.itemInfo && this.itemInfo.itemCategory && this.itemInfo.itemCategory.parentList &&
        this.itemInfo.itemCategory.parentList.length && this.itemInfo.itemCategory.parentList[0].categoryCode === '1032') || (this.itemInfo && this.itemInfo.itemCategory &&
          (this.itemInfo.itemCategory.categoryCode === '13003' || this.itemInfo.itemCategory.categoryCode === '501'))
    },
    // 判断是否课程
    isCourseItem () {
      return this.isOfflineCourse || this.isOnlineCourse
    },
    // 判断是否是Elearning课程
    isElearningCourse () {
      return this.itemInfo && this.itemInfo.itemCategory && (this.itemInfo.itemCategory.categoryCode === '13003' || this.itemInfo.itemCategory.categoryCode === '501')
    },
    // 检查课程报名截止时间
    isCourseCutoff () {
      if (this.itemInfo && this.itemInfo.cutoffTime) {
        let cutoffTime = commonUtils.parseTime(new Date(this.itemInfo.cutoffTime), '{y}-{m}-{d}')
        let curTime = commonUtils.parseTime(new Date(), '{y}-{m}-{d}')
        return cutoffTime < curTime
      }
      return false
    }
  },
  methods: {
    init () {
      this.itemId = this.$route.query.itemId
      this.couponId = this.$route.query.couponId
      this.queryItemInfo()
      this.getClientInfo()
      this.CarnivalSubmit()
    },
    CarnivalSubmit () {
      let that = this
      let wxUserInfo = JSON.parse(localStorage.getItem('userInfo'))
      console.log('wxUserInfo=================', wxUserInfo)
      let data = {
        clientId: wxUserInfo.clientInfo.clientId,
        clientUserId: wxUserInfo.clientInfo.clientUserId,
        activityKey: 'browsePointsMall'
      }
      cartApi.CarnivalSubmit(data).then(ress => {
        console.log('res===', ress)
        let res = ress.data
        if (res.resultData && res.resultData.msg) {
          console.log('res===', res.resultData.msg)
          that.$toast.success(res.resultData.msg)
        }
      })
    },
    // 客户信息获取
    getClientInfo () {
      /*
        isActivated:int, //0未激活 1已激活
        clientStatus:string, //客户状态 01创建 02活跃 03冻结
        verifyStatus:string, //审核状态 01待审核 02已审核
        */
      const { isActivated, clientStatus, verifyStatus } = this.clientInfo
      if (isActivated === 1 && clientStatus !== '03' && verifyStatus === '01') {
        this.userStatus = 1
      } else if (isActivated === 1 && clientStatus !== '03' && verifyStatus === '02') {
        this.userStatus = 2
      }
    },
    getImgUrl (uri) {
      return process.env.VUE_APP_FILE_SERVER + uri
    },
    // 查询礼品详情
    queryItemInfo () {
      let params = {
        itemId: this.itemId || ''
      }
      sortApi.queryItemInfo(params).then(res => {
        if (res.data.resultCode === '0') {
          const { imageList, itemInfo } = res.data.resultData
          this.imageList = imageList
          this.itemInfo = itemInfo
          // 是否有礼品组
          if (this.itemInfo.isGroup === 1 && this.itemInfo.subItemVOs !== undefined) {
            this.hasSubItems = true
          }
          if (this.itemInfo.tagReveal && this.itemInfo.itemTagVO && this.itemInfo.itemTagVO.itemTagType) {
            if (this.itemInfo.itemTagVO.itemTagType === '02') {
              this.itemColorTagList = this.itemInfo.itemTagVO.itemTagNameList
            } else if (this.itemInfo.itemTagVO.itemTagType === '03') {
              this.itemSizeTagList = this.itemInfo.itemTagVO.itemTagNameList
            }
          }
          this.getItemOrderCount()
        }
      })
    },
    getImageUri (mobileImageUri) {
      return process.env.VUE_APP_EXTRA_SITE + mobileImageUri
    },

    // 兑换课程次数
    getItemOrderCount () {
      let params = {
        itemId: this.itemId || ''
      }
      if (!params.itemId) {
        return
      }
      if (!this.isCourseItem) {
        return
      }
      sortApi.getItemOrderCount(params).then(res => {
        if (res.data.resultCode === '0') {
          const { orderCount } = res.data.resultData
          this.orderCount = orderCount
        }
      })
    },
    // 右上角购物车
    shoppingCar () {
      this.$router.push({
        name: 'cart'
      })
    },
    // 收藏
    collection () {
      let params = [{
        itemId: this.itemId
      }]
      if (this.itemInfo.isFavorite === 1) {
        // 取消收藏
        sortApi.removeFavorite(params).then(res => {
          if (res.data.resultCode === '0') {
            this.$toast('取消收藏成功')
            this.queryItemInfo()
          }
        })
      } else if (this.itemInfo.isFavorite === 0) {
        // 添加收藏
        sortApi.addFavorite(params).then(res => {
          if (res.data.resultCode === '0') {
            this.$toast('收藏成功')
            this.queryItemInfo()
          }
        })
      } else {
        this.$toast('收藏成功')
      }
    },
    // 加入购物车
    addToCart () {
      let params = [{
        itemQuantity: 1,
        itemId: this.itemId || ''
      }]
      if (this.itemInfo.mOQ !== undefined && this.itemInfo.mOQMultiple === undefined) {
        params[0].itemQuantity = this.itemInfo.mOQ
      } else if (this.itemInfo.mOQMultiple !== undefined && this.itemInfo.mOQ !== undefined) {
        params[0].itemQuantity = this.itemInfo.mOQMultiple
      } else if (this.itemInfo.mOQMultiple !== undefined && this.itemInfo.mOQ === undefined) {
        params[0].itemQuantity = this.itemInfo.mOQMultiple
      } else {
        params[0].itemQuantity = 1
      }
      if (this.viewStock) {
        this.$toast.loading({
          duration: 0,
          message: '加载中...',
          forbidClick: true
        })
        if (!this.hasSubItems) {
          sortApi.addCar(params).then(res => {
            if (res.data.resultCode === '0') {
              this.$toast('加入购物车成功')
            }
          }).catch(() => { this.$toast.clear() })
        } else {
          if (this.subItemId === -999) {
            this.$toast('请选择礼品种类')
            return
          }
          params[0].itemId = this.subItemId
          params[0].itemQuantity = 1
          sortApi.addCar(params).then(res => {
            if (res.data.resultCode === '0') {
              this.$toast('加入购物车成功')
            }
          }).catch(() => { this.$toast.clear() })
        }
      } else {
        this.$toast('已售完')
      }
    },
    // 打开课程
    viewOnlineCourse () {
      if (this.isElearningCourse) {
        if (this.itemInfo.itemCategory.categoryCode === '501') {
          window.location.href = `/v2/order-link?uri=` + this.itemInfo.itemContentImageUri
        } else {
          // window.location.href = $scope.orderInfo.detailList[0].jumpLink
        }
        return
      }
      sortApi.getElearningToken().then(res => {
        if (res.data.resultCode === '0') {
          const { token } = res.data.resultData.token
          var targetUrl = this.$store.state.base.ApiEndpoint.elearningCourseUrl + '?userCode=' + userUtils.getClientInfo().clientCode + '&couCode=' + this.itemInfo.elearningCode + '&token=' + token
          document.location = targetUrl
        }
      })
    },
    // 线上课程购买
    onlineCourseBuy () {
      if (!this.itemInfo) {
        return
      }
      if (!this.isOnlineCourse) {
        return
      }
      if (this.userStatus === 1) {
        this.$toast('账号待审核')
        return
      }
      if (this.userRole === '03') {
        this.$toast('没有下单权限')
        return
      }
      if (this.isElearningCourse) {
        cartApi.queryCheckCiam().then(res => {
          if (res.data.resultCode === '0') {
            if (res.data.resultData.isCiam === 'false' && this.itemInfo.itemCategory.categoryCode === '13003') {
              this.dialogCiamOption.dialogCiamShow = true
            } else {
              this.onlineCourseBuyNext()
            }
          }
        })
      } else {
        this.onlineCourseBuyNext()
      }
    },
    // 线下课程购买
    offlineCourseBuy () {
      if (!this.itemInfo) {
        return
      }
      if (!this.isOfflineCourse) {
        return
      }
      if (this.isCourseCutoff) {
        this.$toast('课程报名已截止')
        return
      }
      if (this.userStatus === 1) {
        this.$toast('账号待审核')
        return
      }
      if (this.userRole === '03') {
        this.$toast('没有下单权限')
        return
      }
      this.onlineCourseBuyNext()
    },

    onlineCourseBuyNext () {
      let data = {
        itemId: this.itemId,
        itemQuantity: 1
      }
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true
      })
      cartApi.queryCartBuy(data).then(res => {
        if (res.data.resultCode === '0') {
          this.$router.push({
            name: 'direct_buy',
            query: {
              itemId: this.itemId,
              couponId: this.couponId
            }
          })
        }
        this.$toast.clear()
      }).catch(() => { this.$toast.clear() })
    },
    // ciam登录dialog
    dialogCiam () {
      window.location = window.location.origin + `/v2/ciam/login?state=/#/goodsDetail/${this.itemInfo.itemId}`
    },
    // 立即购买
    directBuy () {
      let data = {
        itemQuantity: 1,
        itemId: this.itemId || ''
      }
      if (this.itemInfo.mOQ !== undefined && this.itemInfo.mOQMultiple === undefined) {
        data.itemQuantity = this.itemInfo.mOQ
      } else if (this.itemInfo.mOQMultiple !== undefined && this.itemInfo.mOQ !== undefined) {
        data.itemQuantity = this.itemInfo.mOQMultiple
      } else if (this.itemInfo.mOQMultiple !== undefined && this.itemInfo.mOQ === undefined) {
        data.itemQuantity = this.itemInfo.mOQMultiple
      } else {
        data.itemQuantity = 1
      }
      if (this.userRole === '03') {
        this.$toast('没有下单权限')
        return
      }
      if (this.userStatus === 1) {
        this.$toast('账号待审核')
      } else if (this.userStatus === 2) {
        this.$toast.loading({
          duration: 0,
          message: '加载中...',
          forbidClick: true
        })
        if (!this.hasSubItems) {
          cartApi.queryCartBuy(data).then(res => {
            if (res.data.resultCode === '0') {
              this.$router.push({
                name: 'direct_buy',
                query: {
                  itemId: this.itemId,
                  couponId: this.couponId
                }
              })
            }
            this.$toast.clear()
          }).catch(() => { this.$toast.clear() })
        } else {
          if (this.subItemId === -999) {
            this.$toast('请选择礼品种类')
            return
          }
          data.itemId = this.subItemId
          cartApi.queryCartBuy(data).then(res => {
            if (res.data.resultCode === '0') {
              this.$router.push({
                name: 'direct_buy',
                query: {
                  itemId: this.subItemId,
                  couponId: this.couponId
                }
              })
            }
            this.$toast.clear()
          }).catch(() => { this.$toast.clear() })
        }
      }
    },
    // 选择种类
    toggltSubitem (item, index) {
      this.subItemIndex = index
      this.imageList = item.imageList
      this.subItemId = item.itemInfo.itemId
      let logicalStock = item.itemInfo.logicalStock
      let usableStock = item.itemInfo.usableStock
      let isPreOrder = item.itemInfo.usableStock
      this.viewStock = true
      if (logicalStock === 0 && usableStock === 0 && isPreOrder === 0) {
        this.viewStock = false
      }
      if (logicalStock === 0) {
        this.itemInfo.usableStock = usableStock
      } else {
        this.itemInfo.usableStock = logicalStock
      }
    },

    updateSelected (index, type, tagName) {
      let params = {
        itemId: this.itemInfo.itemId
      }
      switch (type) {
        case '01':
          this.shapeItemIndex = index
          this.colorItemIndex = -1
          this.sizeItemIndex = -1
          this.itemColorTagList = []
          this.itemSizeTagList = []
          params.itemTagTypes = '01'
          params.tagNames = tagName
          this.subItemId = -999
          break
        case '02':
          this.sizeItemIndex = -1
          this.itemSizeTagList = []
          this.colorItemIndex = index
          this.subItemId = -999
          if (this.itemInfo.itemTagVO.itemTagType === '01') {
            params.tagNames = this.itemInfo.itemTagVO.itemTagNameList[this.shapeItemIndex] + ',' + tagName
            params.itemTagTypes = '01,02'
          } else if (this.itemInfo.itemTagVO.itemTagType === '02') {
            params.tagNames = tagName
            params.itemTagTypes = '02'
          }
          break
        case '03':
          this.sizeItemIndex = index
          let label = (this.itemInfo.itemTagVO.itemTagNameList[this.shapeItemIndex] || '') + (this.itemColorTagList[this.colorItemIndex] || '') + tagName
          for (let item of this.itemInfo.subItemVOs) {
            if (item.itemInfo.showLabel === label) {
              this.subItemId = item.itemInfo.itemId
            }
          }
          break
        default:
          break
      }
      if (type === '02' || type === '01') {
        sortApi.queryTag(params).then(res => {
          if (res.data.resultCode === '0') {
            if (res.data.resultData.itemTagType && res.data.resultData.itemTagType === '02') {
              this.itemColorTagList = res.data.resultData.tagNameList
            } else if (res.data.resultData.itemTagType && res.data.resultData.itemTagType === '03') {
              this.itemSizeTagList = res.data.resultData.tagNameList
            }
          }
        })
      }
    },
    onClickLeft () {
      if (location.href.indexOf('#backHome') === -1) {
        this.$router.go(-1)
      } else {
        this.$router.push({ name: 'home-main' })
      }
    }
  }
}
</script>

<style scoped lang="less">
.home-swipe {
  .van-img {
    width: 100%;
    height: 100%;
  }
}

.goods-detail-nav {
  padding: 0.3rem;
  font-size: 0.3rem;
  background-color: #fff;

  .container {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin: 0.3rem 0;

    .good-name {
      font-size: 0.45rem;
    }
  }

  .subItemLink {
    font-size: 0.35rem;
    justify-content: flex-start;

    .subItemLink-item {
      display: flex;
      padding-bottom: 0.15rem;
    }
  }
}

.search-result-oldintegration {
  color: #c2c2c2;
  font-size: 0.24rem;
  text-decoration: line-through;
}

.order-count {
  color: red;
  font-size: 0.3rem;
  margin-top: 0.15rem;
}

.lesson {
  display: flex;
  margin-top: 0.15rem;
  font-size: 0.3rem;
}

.col-75 {
  flex: 0 0 75%;
  max-width: 75%;
}

.col-25 {
  flex: 0 0 25%;
  max-width: 25%;
}

.col-33 {
  flex: 0 0 33%;
  max-width: 33%;
}

.color333 {
  color: #333;
}

.theme-red-color {
  color: #e20015;
}

.goods-collection-icon {
  display: inline-block;
  width: 0.42rem;
  height: 0.42rem;
  background: url(https://wx.bosch-extra.com.cn/img/sort/goods-collection-icon.png);
  background-size: contain;
}

.goods-collectioned-icon {
  display: inline-block;
  width: 0.42rem;
  height: 0.42rem;
  background: url(https://wx.bosch-extra.com.cn/img/collectioned.png);
  background-size: contain;
}

.goods-share-icon {
  display: inline-block;
  width: 0.42rem;
  height: 0.42rem;
  margin: 0rem 0.3rem;
  background: url(https://wx.bosch-extra.com.cn/img/sort/goods-share-icon.png);
  background-size: contain;
}

.fixed {
  .flex-1 {
    flex: 1 1 0;
  }
}

.tabs /deep/ .van-tabs__content {
  min-height: auto !important;
}

.goods-option {
  background-color: #fff;
  margin: 0.3rem 0;
  padding: 0.3rem;

  .goods-type {
    display: flex;
    align-items: center;

    .subItem-name {
      margin-right: 0.4rem;
      flex: 0 0 16%;
    }

    .subItem-list {
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      .active {
        background-color: var(--base-green);
        color: #fff
      }
    }

  }

}
</style>
<style lang="less">
.goods-html {
  background-color: white;
  line-height: 2;
  font-size: 0.35rem;
  height: auto;

  p {
    width: 100% !important;
  }

  img {
    width: 100% !important;
  }
}

.goods-html-specInfo {
  padding: 0.25rem;
}
</style>
